<template>
  <transition name="slideFromBottom">
    <div class="infoOverlay">
      <div class="infoOverlay__close"
           @click="closeInfoOverlay">
        <span>&times;</span>
      </div>
      <div class="infoOverlay__content">
        <carousel v-if="config.slides"
                  :perPage="1">
          <slide :key="slide.id"
                 v-for="slide in config.slides"
                 class="infoOverlay__content__slide">
            <info-slide :config="slide"></info-slide>
          </slide>
        </carousel>
      </div>
    </div>
  </transition>
</template>

<script>
  import Slide from './Slide.vue';

  export default{
    props: ['infoConfig'],
    data(){
      return{
        config: this.infoConfig
      }
    },
    components:{
      'info-slide': Slide
    },
    methods:{
      closeInfoOverlay(){
        var vm = this;
        vm.$emit('close-overlay');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/info/Overlay.vue